import CarEntity from '../../domain/entities/CarEntity';

export class CarDto {
    static fromJson(json: any): CarEntity {
        return {
            brand: json['brand'] || '',
            model: json['model'] || '',
            color: json['color'] || '',
            plate: json['plate'] || '',
        };
    }

    static toJson(car: CarEntity): any {
        return {
            brand: car.brand,
            model: car.model,
            color: car.color,
            plate: car.plate,
        };
    }
}

export default CarDto;
